<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="SP"> </p>
<section epub:type="dedication" role="doc-dedication">
<p class="Dedication-ded" id="ded"><span aria-label="v" id="pg_v" role="doc-pagebreak"><i>In memory of Stephen F. Bashford— one of the really good guys. Gone too soon.</i></span></p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?d474f816